var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 43,
    viewBox: "0 0 60 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1517 17.9953C49.1517 8.58613 41.5241 0.958496 32.1149 0.958496C22.7057 0.958496 15.0781 8.58613 15.0781 17.9953H12.1727C5.45116 17.9953 0.00219727 23.4443 0.00219727 30.1658C0.00219727 36.8873 5.45116 42.3363 12.1727 42.3363H47.2567L59.1221 30.4709V17.9953H49.1517Z",
    fill: "url(#paint0_linear_128_263)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.9864 4.57812C23.7384 4.57812 22.5119 4.66705 21.3068 4.82497C17.5029 7.94961 15.0759 12.6887 15.0759 17.9966H12.1705C5.44896 17.9966 0 23.4456 0 30.1671C0 36.8886 5.44896 42.3376 12.1705 42.3376H47.2545L52.912 36.6801C53.0883 35.4045 53.1864 34.1028 53.1864 32.7781C53.1864 17.2024 40.5621 4.57812 24.9864 4.57812Z",
    fill: "#0F2A56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.3365 35.0949C20.9526 35.0949 10.9777 29.0726 5.41677 20.0405C2.15107 22.2238 0 25.9433 0 30.1657C0 36.8872 5.44896 42.3362 12.1705 42.3362H47.2545L59.1199 30.4708V20.2521C53.5345 29.1661 43.63 35.0949 32.3365 35.0949Z",
    fill: "#0F2A56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.1511 17.9952C49.1511 15.1036 48.4274 12.3822 47.1549 9.99658H32.9728C30.0981 22.8202 23.1068 34.0861 13.4584 42.3362H47.253L59.1184 30.4708V17.9952H49.1511Z",
    fill: "#0F2A56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.985 42.3377H47.2545L59.1198 30.4723V9.99805H32.985V42.3377Z",
    fill: "url(#paint1_linear_128_263)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M41.6031 9.99805H32.985V42.3377H47.2545L52.9119 36.6802C53.0883 35.4046 53.1864 34.1029 53.1864 32.7782C53.1864 23.4181 48.6236 15.1266 41.6031 9.99805Z",
    fill: "#C11D0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M41.6031 9.99805H32.985V42.3377H47.2545L52.9119 36.6802C53.0883 35.4046 53.1864 34.1029 53.1864 32.7782C53.1864 23.4181 48.6236 15.1266 41.6031 9.99805Z",
    fill: "#C15F0E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M32.985 35.0859V42.3395H47.2545L59.1198 30.4741V20.2554C53.6417 28.9946 44.0087 34.8621 32.985 35.0859Z",
    fill: "#840977"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2545 30.4727H59.1198L47.2545 42.338V30.4727Z",
    fill: "url(#paint2_linear_128_263)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M32.9851 9.99805L30.5627 42.3377H32.9851V9.99805Z",
    fill: "#0F2A56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.2545 30.4727C45.7719 38.3165 40.6556 42.338 40.6556 42.338H47.2545V30.4727Z",
    fill: "#0F2A56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6931 13.603L41.5797 16.545L46.6931 19.487L51.8065 16.545L46.6931 13.603Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5989 23.4968L45.7824 26.4914V20.52L40.5989 17.5254V23.4968Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9032 26.4914L52.0867 23.4968V17.5254L46.9032 20.52V26.4914Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_128_263",
    x1: 14.502,
    y1: 54.0504,
    x2: 37.7472,
    y2: 14.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283E99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ED4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_128_263",
    x1: 25.3721,
    y1: 51.211,
    x2: 55.1311,
    y2: 6.63627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC15E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68003E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_128_263",
    x1: 37.1727,
    y1: 54.3508,
    x2: 51.4774,
    y2: 33.0214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B53D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E433A1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.4db79137fe431bdffd60e33877d425a3.svg";
export { ForwardRef as ReactComponent };